'use client';

import { createContext, ReactNode, useContext, useMemo } from 'react';
import { Api } from './';
import { makeProjectKeys } from '@/app/hooks/query-keys';
import { getApiUrl } from './utils';

const ApiContext = createContext<Api | null>(null);

export function ApiProvider({
  children,
  documentSetId,
}: {
  children: ReactNode;
  documentSetId?: number;
}) {
  const api = useMemo(() => {
    return new Api({ baseUrl: getApiUrl(), documentSetId });
  }, [documentSetId]);

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi(): Api {
  const api = useContext(ApiContext);
  if (!api) throw new Error('useApi must be used within <ApiProvider>');
  return api;
}

export function useProjectKeys() {
  const { documentSetId } = useApi();
  return useMemo(() => makeProjectKeys(documentSetId), [documentSetId]);
}
